import React, { useState } from "react";
import "../../../static/css/App.css";
import OrderTable from "../orderTable";
const ConfirmedOrders = () => {
  return <OrderTable status={2} isActive="confirmed" />;
};

export default ConfirmedOrders;
